import { DebtSummary, Employer, GetApplicationData } from 'handlers/applicationData';

import { CardColor } from 'components/CardFlow/Customize/cardVersions';
import { ReferralProgram } from 'handlers/cardData';
import { ProfessionGroup } from 'enums/ProfessionGroup';

import Api, { FetchMethodType } from './Api';
import { UtmTags } from './LoanOfferApi';

export interface CardApplyResponse {
  applicationId: string;
  borrowerId: string;
  referralLink: string;
  referredBy: string;
  applied: boolean;
  debtSummary: DebtSummary;
  debtConsolidationPossible: boolean;
  waitListPosition: number;
  originalWaitListPosition: number;
  totalDebt: number | null;
  cardColor: CardColor;
  borrowerCredentials: string;
  referralProgram: ReferralProgram;
  waitListLength: number;
  professionGroup: ProfessionGroup;
  totalAnnualIncome: number;
}

interface JoinWaitlistCommonData {
  cardReferredBy?: string;
  httpReferrer?: string;
  smartSpendingLimitsEnabled?: boolean;
  smartAutoPayEnabled?: boolean;
  importDebtEnabled?: boolean;
}

export interface JoinWaitlistData extends JoinWaitlistCommonData {
  email: string;
  firstName: string;
  lastName: string;
  professionGroup: ProfessionGroup;
  credentials: string;
  phoneNumber: string;
  cardColor: CardColor;
  methodEntityId?: string;
  utm: UtmTags;
  resumeLink: string;
  notEmployed?: boolean;
  totalAnnualIncome?: number;
  timezone: string;
  partnerId?: string;
  sessionToken?: string;
  employment?: Employer[];
  creditScoreRange?: string;
}

export interface JoinWaitlistWithLoanOfferData extends JoinWaitlistCommonData {
  applicationId: string;
}

export interface GetCardApplicationResponse {
  application: GetApplicationData;
  waitListLength: number;
}

export interface CardApi {
  getCardDataForLoanApplication(applicationId: string): Promise<GetCardApplicationResponse>;
  joinWaitList(data: JoinWaitlistData): Promise<CardApplyResponse>;
  joinWaitListWithLoanOffer(data: JoinWaitlistWithLoanOfferData): Promise<CardApplyResponse>;
}

export default class CardRestApi extends Api implements CardApi {
  async getCardDataForLoanApplication(applicationId: string): Promise<GetCardApplicationResponse> {
    return this.fetch<GetCardApplicationResponse>(`/card/${applicationId}`);
  }

  async joinWaitList(data: JoinWaitlistData): Promise<CardApplyResponse> {
    return this.fetch<CardApplyResponse>('/card/joinWaitList', {
      method: FetchMethodType.POST,
      body: data,
    });
  }

  async joinWaitListWithLoanOffer(data: JoinWaitlistWithLoanOfferData): Promise<CardApplyResponse> {
    return this.fetch<CardApplyResponse>(`/card/joinWaitList/${data.applicationId}`, {
      method: FetchMethodType.POST,
      body: {
        cardReferredBy: data.cardReferredBy,
        httpReferrer: data.httpReferrer,
        smartSpendingLimitsEnabled: data.smartSpendingLimitsEnabled,
        smartAutoPayEnabled: data.smartAutoPayEnabled,
        importDebtEnabled: data.importDebtEnabled,
      },
    });
  }
}
